import axios from "axios";

const getHeaders = (profile = {}) => {
  const orgId = profile?.orgId || profile?.organizationId || profile?.["custom:orgId"];
  const region = sessionStorage.getItem("userRegion") || "AP";

  return {
    "Content-Type": "application/json",
    Region: region,
    ...(orgId ? { organizationId: orgId } : {}),
  };
};
const getPublicHeaders = () => ({
  "Content-Type": "application/json",
  Region: sessionStorage.getItem("userRegion") || "AP",
});
export const getOrgId = (profile = {}, userData = {}) => {
  return (
    profile?.orgId ||
    profile?.organizationId ||
    profile?.["custom:orgId"] ||
    userData?.orgId ||
    userData?.organizationId ||
    userData?.["custom:orgId"] ||
    userData?.email
  );
};

export const getPublicBaseUrl = () => window.location.origin;

export const publicConsentUrl = (token) => {
  return `https://demo.securecloud.tech/consent/${token}`;
};

/* ─── CONSENT FORMS ─── */

export const createConsentFormApi = (profile, payload) =>
  axios.post(
    "https://vx45jre5r6.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/consent/forms",
    payload,
    { headers: getHeaders(profile) }
  );

export const fetchConsentFormsApi = (profile, organizationId) =>
  axios.get(
    "https://vx45jre5r6.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/consent/forms",
    {
      params: { organizationId },
      headers: getHeaders(profile),
    }
  );

export const fetchConsentFormByIdApi = (profile, formId, organizationId) =>
  axios.get(
    `https://9dmfw6i8d4.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/consent/forms/${formId}`,
    {
      params: { organizationId },
      headers: getHeaders(profile),
    }
  );

export const updateConsentFormApi = (profile, formId, organizationId, payload) =>
  axios.put(
    `https://9dmfw6i8d4.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/consent/forms/${formId}`,
    payload,
    {
      params: { organizationId },
      headers: getHeaders(profile),
    }
  );

export const publishConsentFormApi = (profile, formId, organizationId) =>
  axios.post(
    `https://3qhx3u79rl.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/consent/forms/${formId}/publish`,
    {},
    {
      params: { organizationId },
      headers: getHeaders(profile),
    }
  );

/* ─── CONSENT LINKS ─── */

export const generateConsentLinkApi = (profile, payload) =>
  axios.post(
    "https://63x22warm4.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/consent-links/generate",
    payload,
    { headers: getHeaders(profile) }
  );

export const fetchConsentLinksApi = (profile, organizationId) =>
  axios.get(
    "https://eiockrqtu0.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/consent-links",
    {
      params: { organizationId },
      headers: getHeaders(profile),
    }
  );

export const revokeConsentLinkApi = (profile, token) =>
  axios.put(
    `https://6eynn4mp9i.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/consent-links/${token}/revoke`,
    {},
    { headers: getHeaders(profile) }
  );

/* ─── PUBLIC CONSENT FORM ─── */

export const fetchPublicConsentFormApi = (token) =>
  axios.get(
    `https://kebaipjlsb.execute-api.ap-southeast-2.amazonaws.com/prod/public/consent-links/${token}`,
    {
      headers: {
        "Content-Type": "application/json",
        Region: sessionStorage.getItem("userRegion") || "AP",
      },
    }
  );

export const submitPublicConsentApi = (token, payload) =>
  axios.post(
    `https://t4s76x8yuf.execute-api.ap-southeast-2.amazonaws.com/prod/public/consent-links/${token}/submit`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Region: sessionStorage.getItem("userRegion") || "AP",
      },
    }
  );

/* ─── CONSENT DASHBOARD ─── */

export const fetchConsentSubmissionsApi = (profile, organizationId) =>
  axios.get(
    "https://26zdzbrnwl.execute-api.ap-southeast-2.amazonaws.com/prod/public/consent-links/submissions",
    {
      params: { organizationId },
      headers: getHeaders(profile),
    }
  );